

const Manifesto = () => {

    return (

        <div style={{ width: "100%", height: "100vh" }}>
        <iframe
            src="https://manifesto.hospitaissaudaveis.org.br/?token=8e317e3c-17b5-4b3c-b388-1a629dd24897"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
            title="Site Manifesto"
        />
        </div>

    )

}

export default Manifesto;